<template>
  <v-dialog
    v-model="isDialog"
    fullscreen
    transition="dialog-bottom-transition"
    @keydown.esc="closePdfDialog"
    class="pdfViewContainer"
  >
    <v-card v-if="isDialog && pdf">
      <div style="z-index: 1; position: absolute; top: 0; right: 0">
        <v-btn icon @click="closePdfDialog" class="ma-2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <pdf-viewer :pdf="pdf" @onImageExport="onImageExport" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import PdfViewer from "@/components/files/PdfViewer.vue";

@Component({
  components: {
    PdfViewer
  }
})
export default class PdfUploadDialog extends Vue {
  @Prop()
  isDialog!: boolean;

  @Prop()
  pdf!: File;

  closePdfDialog(data: any) {
    this.$emit("closePdfDialog", data);
  }

  onImageExport(data: any) {
    this.$emit("onImageExport", data);
  }
}
</script>

<style></style>
